const wrapper = "_vcwgh2m66";
const text = "_vct6smu0y";
const content = "_vcculmp5v";
const title = "_vct1fcmklr";

export { content, text, title, wrapper };
import "./_player.style.linaria.module.css";
//# sourceMappingURL=_player.style.js.map
